"use client";

import { FC } from "react";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";

import { useStyles } from "./styles";

const AVATAR_COLOURS = [
  "#4B0082", // Indigo
  "#483D8B", // Dark Slate Blue
  "#2F4F4F", // Dark Slate Gray
  "#556B2F", // Dark Olive Green
  "#8B4513", // Saddle Brown
  "#4682B4", // Steel Blue
  "#6A5ACD", // Slate Blue
  "#7B68EE", // Medium Slate Blue
  "#3CB371", // Medium Sea Green
  "#8FBC8F", // Dark Sea Green
];

interface PlayerCardProps {
  index: number;
  name: string;
  avatarUrl: string | null;
  isActive?: boolean;
  isHost?: boolean;
  hideLabel?: boolean;
  size?: "small" | "medium" | "large";
}

const PlayerCard: FC<PlayerCardProps> = ({
  index,
  name,
  avatarUrl,
  isActive = false,
  isHost = false,
  hideLabel = false,
  size = "large",
}) => {
  const backgroundColor = AVATAR_COLOURS[index % AVATAR_COLOURS.length];
  const { classes } = useStyles({ backgroundColor, size });

  return (
    <div key={name} className={classes.playerCard} title={name}>
      <Badge
        className={classes.badge}
        overlap="circular"
        variant="dot"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        invisible={!isActive}
      >
        <Avatar src={avatarUrl || ""} alt={name} className={classes.avatar}>
          {name[0].toUpperCase()}
        </Avatar>
      </Badge>
      {!hideLabel && <p className={classes.playerName}>{name}</p>}
      {isHost && <p>(Host)</p>}
    </div>
  );
};

export default PlayerCard;
